import { Component } from '@angular/core';

@Component({
    selector: 'app-account-locked',
    templateUrl: './account-locked.component.html',
    standalone: false
})
export class AccountLockedComponent {
}
